import { redirect } from "react-router";

import { store } from "../../../../..";
import {
    clubhouseActions,
    selectSelectedTeam,
} from "../../../../../features/clubhouse/clubhouseSlice";
import {
    globalActions,
    selectSetting,
} from "../../../../../features/global/globalSlice";
import { getRoster, getTeam } from "../../../../../lib/api";

const rosterLoader = async ({ params }: any) => {
    let { teamId } = params;
    teamId = parseInt(teamId);

    const state = store.getState();
    const { user } = state.auth;
    const league = state.clubhouse.league;
    const settings = state.global.settings;
    const clubhouseTeams = state.clubhouse.teams;

    let currentTeam = selectSelectedTeam(state);

    const promises = [];

    !clubhouseTeams.length &&
        promises.push(
            store.dispatch(
                clubhouseActions.getTeams({ userId: user?.id as number }),
            ),
        );

    !settings.length &&
        promises.push(store.dispatch(globalActions.getSettings()));

    const teamPromise =
        currentTeam?.id === teamId ? Promise.resolve() : getTeam(teamId);

    const [fetchedTeam] = await Promise.all([teamPromise, ...promises]);

    const currentYear = parseInt(
        selectSetting(store.getState(), "majorybl_current_league_year")
            ?.setting,
    );

    let team = currentTeam
        ? currentTeam.id === teamId
            ? currentTeam
            : fetchedTeam?.team
        : fetchedTeam?.team;

    let currentTeamsLeague = team?.leagues?.find(l => l.year === currentYear);

    if (!league && currentTeamsLeague) {
        await store.dispatch(clubhouseActions.getLeague(currentTeamsLeague.id));
    }

    if (team?.id !== teamId) {
        store.dispatch(clubhouseActions.setSelectedLeagueTeam(teamId));
    }

    const currentAgeLevel = team?.ageLevels.find(t => t.year === currentYear);

    const teamAgeLevel = team?.ageLevels.reduce((prev, current) => {
        return new Date(current.year, current.season.id) >
            new Date(prev.year, prev.season.id)
            ? current
            : prev;
    }, team?.ageLevels[0]);

    const ageLevel = currentAgeLevel || teamAgeLevel;

    const header = `${team?.name} ${ageLevel ? `(${ageLevel.ageLevel})` : ""} / Roster`;

    if (!team?.leagues) {
        return redirect("/coachs-clubhouse");
    } else {
        const { players: roster } = await getRoster(
            teamId,
            currentTeamsLeague?.id,
        );

        return {
            teamId,
            roster,
            header,
        };
    }
};

export default rosterLoader;
